// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `img {
  max-width: 100%;
}

.flex {
  display: flex;
  flex-wrap: wrap;
}

.dir-col {
  flex-direction: column;
}

.dir-col-rev {
  flex-direction: column-reverse;
}

.mh-full {
  min-height: 100%;
}

.mt-auto {
  margin-top: auto;
}

.bt-0 {
  border-top: 0;
}

.bb-0 {
  border-bottom: 0;
}

.fn-body h1,
.fn-body h2,
.fn-body h3,
.fn-body h4,
.fn-body h5,
.fn-body h6 {
  --hGap: 10px;
  font-family: "Museo-700";
  color: #6d6e71;
  margin-bottom: var(--hGap);
  margin-top: 0;
}
.fn-body h1:last-child,
.fn-body h2:last-child,
.fn-body h3:last-child,
.fn-body h4:last-child,
.fn-body h5:last-child,
.fn-body h6:last-child {
  margin-bottom: 0;
}
.fn-body h1,
.fn-body .h1-text {
  font-size: 44px;
  line-height: 1.1;
}
@media only screen and (max-width: 767px) {
  .fn-body h1,
  .fn-body .h1-text {
    font-size: 38px;
  }
}
.fn-body h2,
.fn-body .h2-text {
  font-size: 38px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h2,
  .fn-body .h2-text {
    font-size: 32px;
  }
}
.fn-body h3,
.fn-body .h3-text {
  font-size: 32px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h3,
  .fn-body .h3-text {
    font-size: 24px;
  }
}
.fn-body h4,
.fn-body .h4-text {
  font-size: 24px;
  line-height: 1.2;
}
.fn-body h5,
.fn-body .h5-text {
  font-size: 18px;
  line-height: 1.2;
}
.fn-body h6,
.fn-body .h6-text {
  font-size: 16px;
  line-height: 1.3;
}
.fn-body p {
  font-size: 18px;
  line-height: 1.6;
  color: #6a6a6a;
  margin-top: 0;
  margin-bottom: 10px;
}
.fn-body p:last-child {
  margin-bottom: 0;
}
@media only screen and (max-width: 767px) {
  .fn-body p {
    font-size: 16px;
  }
}
.fn-body ul,
.fn-body ol {
  padding: 0;
  margin: 0;
}
.fn-body sup {
  font-size: 0.7em;
  position: relative;
  top: 5px;
  display: inline-block;
  vertical-align: top;
}

.bg-grey {
  background-color: #eee;
}

.fn-container {
  max-width: 1080px;
  width: calc(100% - 30px);
  margin-inline: auto;
}
@media only screen and (min-width: 992px) {
  .fn-container {
    margin-left: 0;
  }
}
.fn-container--fluid {
  max-width: 1200px;
}
.fn-container--small {
  max-width: 820px;
  width: 100%;
}

.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}

.d-none {
  display: none;
}

.section-title {
  text-align: center;
}
.section-title:not(:last-child) {
  margin-bottom: 40px;
}
.section-title h2:not(:last-child) {
  margin-block-end: 20px;
}
.section-title p {
  max-width: 900px;
  width: 100%;
  margin-inline: auto;
  font-size: 22px;
}
.section-title p:not(:last-child) {
  margin-block-end: 20px;
}
@media only screen and (max-width: 767px) {
  .section-title p {
    font-size: 18px;
  }
}
.section-title .section-title__linkcontainer {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.section-title .section-title__linkcontainer:not(:last-child) {
  margin-block-end: 20px;
}
.section-title .section-title__linkcontainer > * {
  margin: 5px;
}
.section-title .section-title__linkcontainer .fn-btn {
  padding-block: 6px;
  padding-inline: 13px;
  font-size: 12px;
  font-family: "MuseoSans-300";
}

.section-padding {
  padding-block: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding {
    padding-block: 40px;
  }
}
.section-padding-small {
  padding-block: 30px;
}
.section-padding-all {
  padding: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding-all {
    padding: 30px;
  }
}
.section-padding-all-small {
  padding: 30px;
}

.headline {
  --lineSize: 10px;
  width: -moz-fit-content;
  width: fit-content;
  padding-block-end: calc(10px + var(--lineSize));
  margin-inline: auto;
  position: relative;
}
.headline--small-border {
  --lineSize: 6px;
}
.headline:not(:last-child) {
  margin-bottom: calc(var(--hGap) * 2.5);
}
.headline::before {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: var(--lineSize);
  background: linear-gradient(90deg, rgb(0, 173, 208) 0%, rgb(0, 173, 208) 25%, rgb(255, 121, 0) 25%, rgb(255, 121, 0) 50%, rgb(105, 190, 40) 50%, rgb(105, 190, 40) 75%, rgb(245, 67, 89) 75%, rgb(245, 67, 89) 100%);
}

.custom-list li {
  font-size: 18px;
  line-height: 1.4;
  color: #6a6a6a;
  list-style: none;
  position: relative;
  padding-left: 15px;
}
.custom-list li:not(:last-child) {
  margin-bottom: 4px;
}
.custom-list li::before {
  content: "";
  position: absolute;
  top: 10px;
  left: 0;
  width: 3px;
  height: 3px;
  background-color: var(--clrProfile);
}

.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.fn-btn {
  padding-block: 20px;
  padding-inline: 28px;
  background-color: rgb(105, 190, 40);
  color: #fff;
  font-size: 18px;
  line-height: 1.2;
  display: inline-block;
  font-family: "Museo-700";
  text-decoration: none;
  word-break: break-all;
  text-align: center;
  transition: background-color 0.3s;
}
.fn-btn:focus {
  outline: 1px dashed #6a6a6a;
  outline-offset: 4px;
}
.fn-btn:hover {
  background-color: #6d6e71;
  color: #fff;
}
.fn-btn--sm {
  font-size: 14px;
  padding-block: 10px;
  padding-inline: 20px;
}
.fn-btn--grey {
  background-color: #f1f1f2;
  color: #6d6e71;
}
.fn-btn--ongoing {
  background-color: #f8ac59;
  color: #fff;
}
.fn-btn--ongoing i {
  animation: spin 0.3s infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.w-4 {
  width: 33.3333333333%;
}

.w-3 {
  width: 25%;
}
.w-3--wd {
  width: 33.3333333333%;
}

.w-6 {
  width: 50%;
}

.fn-row {
  --rGap: 15px;
  --rGap-minus: calc(-1 * var(--rGap));
  display: flex;
  flex-wrap: wrap;
  margin-inline: var(--rGap-minus);
}
.fn-row--col-gap-exist .fn-col {
  margin-bottom: 30px;
}
.fn-col {
  padding-inline: var(--rGap);
}
.fn-justify-center {
  justify-content: center;
}
.fn-items-center {
  align-items: center;
}

.mx-auto {
  margin-inline: auto;
}
.ml-auto {
  margin-inline-start: auto;
}
.ml-0 {
  margin-inline-start: 0;
}
.mr-auto {
  margin-inline-end: auto;
}
.mr-0 {
  margin-inline-end: 0;
}

.asmt-page {
  min-height: 100vh;
  background: #f1f1f2;
  display: flex;
  flex-direction: column;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  color: #676a6c;
  -webkit-font-smoothing: antialiased;
}

.asmt-topbar {
  background: #333333;
  border-bottom: 3px solid rgb(105, 190, 40);
}
.asmt-topbar__inner {
  max-width: 860px;
  margin: 0 auto;
  padding: 18px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}
@media (max-width: 640px) {
  .asmt-topbar__inner {
    padding: 14px 18px;
  }
}
.asmt-topbar__logo {
  height: 32px;
  width: auto;
  display: block;
}
.asmt-topbar__meta {
  display: inline-flex;
  align-items: center;
  gap: 9px;
  font-size: 11.5px;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.72);
}
.asmt-topbar__meta::before {
  content: "";
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: rgb(105, 190, 40);
  flex-shrink: 0;
}
@media (max-width: 560px) {
  .asmt-topbar__meta {
    display: none;
  }
}

.asmt-shell {
  width: 100%;
  max-width: 860px;
  margin: 0 auto;
  padding: 0 16px;
}

.asmt-shell--narrow {
  max-width: 520px;
}

.asmt-hero {
  width: 100%;
  max-width: 860px;
  margin: 0 auto;
  padding: 48px 16px 12px;
}
@media (max-width: 640px) {
  .asmt-hero {
    padding: 36px 18px 8px;
  }
}

.asmt-eyebrow {
  display: inline-block;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: #006174;
  margin: 0 0 16px;
}

.asmt-hero__title {
  font-family: "Museo-700", "Open Sans", "Helvetica Neue", Arial, sans-serif;
  font-weight: 400;
  color: #6d6e71;
  font-size: 52px;
  line-height: 1.04;
  letter-spacing: -0.02em;
  margin: 0 0 18px;
}
@media (max-width: 640px) {
  .asmt-hero__title {
    font-size: 34px;
  }
}

.asmt-hero__lede {
  font-size: 18px;
  line-height: 1.6;
  color: #676a6c;
  max-width: 62ch;
  margin: 0;
}

.asmt-hero__context {
  font-size: 15px;
  line-height: 1.5;
  color: #8a8d91;
  margin: -6px 0 18px;
}
.asmt-hero__context strong {
  color: #6d6e71;
  font-weight: 700;
}

.asmt-title {
  font-family: "Museo-700", "Open Sans", "Helvetica Neue", Arial, sans-serif;
  font-weight: 400;
  color: #6d6e71;
  font-size: 32px;
  line-height: 1.12;
  letter-spacing: -0.015em;
  margin: 0 0 12px;
}
@media (max-width: 640px) {
  .asmt-title {
    font-size: 26px;
  }
}

.asmt-lede {
  font-size: 16px;
  line-height: 1.62;
  margin: 0 0 8px;
  color: #676a6c;
}

.asmt-lede--muted {
  color: #8a8d91;
  font-size: 14.5px;
}

.asmt-section {
  font-family: "Museo-700", "Open Sans", "Helvetica Neue", Arial, sans-serif;
  font-weight: 400;
  color: #6d6e71;
  font-size: 20px;
  letter-spacing: -0.01em;
  margin: 32px 0 12px;
}
@media (max-width: 640px) {
  .asmt-section {
    font-size: 18px;
  }
}

.asmt-card {
  background: #fff;
  border: 1px solid #e7eaec;
  border-radius: 18px;
  padding: 36px 40px;
  margin-bottom: 22px;
  box-shadow: 0 1px 2px rgba(51, 51, 51, 0.05), 0 12px 30px -18px rgba(51, 51, 51, 0.16);
}
@media (max-width: 640px) {
  .asmt-card {
    padding: 24px 20px;
    border-radius: 14px;
  }
}

.asmt-field {
  margin-bottom: 18px;
}
.asmt-field label {
  display: block;
  font-size: 11.5px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #6d6e71;
  margin-bottom: 7px;
}
.asmt-field .form-control {
  width: 100%;
  padding: 12px 14px;
  font-size: 15px;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  color: #6d6e71;
  border: 1.5px solid #e7eaec;
  border-radius: 10px;
  background: #fff;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}
.asmt-field .form-control:focus {
  border-color: rgb(0, 173, 208);
  box-shadow: 0 0 0 4px rgba(0, 173, 208, 0.14);
  outline: none;
}
.asmt-field .form-control.ng-invalid.ng-touched {
  border-color: rgb(245, 67, 89);
}
.asmt-field select.form-control {
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8'%3E%3Cpath fill='%23767b83' d='M6 8 0 0h12z'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 16px center;
  padding-right: 40px;
}

.asmt-error {
  margin-top: 6px;
  font-size: 12.5px;
  font-weight: 600;
  color: #f31c37;
}

.asmt-req {
  color: rgb(245, 67, 89);
}

.asmt-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 9px;
  padding: 12px 24px;
  font-size: 14px;
  font-weight: 700;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  border: 1.5px solid #d3d6d8;
  border-radius: 8px;
  cursor: pointer;
  letter-spacing: 0.01em;
  background: #fff;
  color: #676a6c;
  transition: background-color 0.15s ease, border-color 0.15s ease, color 0.15s ease;
}
.asmt-btn:hover {
  border-color: #6d6e71;
  color: #6d6e71;
}
.asmt-btn[disabled] {
  opacity: 0.45;
  cursor: not-allowed;
}
.asmt-btn--primary {
  background: #4d8b1d;
  color: #fff;
  border-color: #4d8b1d;
}
.asmt-btn--primary:hover {
  background: #3f7218;
  border-color: #3f7218;
  color: #fff;
}
.asmt-btn--primary[disabled]:hover {
  background: #4d8b1d;
  border-color: #4d8b1d;
}
.asmt-btn--block {
  width: 100%;
}
.asmt-btn--lg {
  padding: 14px 30px;
  font-size: 15px;
}

.asmt-note {
  display: flex;
  gap: 10px;
  align-items: flex-start;
  padding: 14px 16px;
  border-radius: 12px;
  font-size: 14px;
  line-height: 1.55;
  color: #676a6c;
  background: rgba(0, 173, 208, 0.07);
  border: 1px solid rgba(0, 173, 208, 0.22);
}
.asmt-note .fa {
  color: #007a93;
  margin-top: 2px;
  font-size: 15px;
}

.asmt-state {
  text-align: center;
  padding: 64px 24px;
}
.asmt-state .fa {
  font-size: 44px;
  color: #8a8d91;
  margin-bottom: 16px;
}
.asmt-state h2 {
  font-family: "Museo-700", "Open Sans", "Helvetica Neue", Arial, sans-serif;
  font-weight: 400;
  font-size: 24px;
  color: #6d6e71;
  margin: 0 0 10px;
}
.asmt-state p {
  color: #8a8d91;
  margin: 0;
  font-size: 15px;
}

.asmt-terms {
  display: flex;
  gap: 12px;
  align-items: flex-start;
  font-size: 13.5px;
  line-height: 1.55;
  color: #676a6c;
  cursor: pointer;
}
.asmt-terms input {
  margin-top: 3px;
  flex-shrink: 0;
  width: 17px;
  height: 17px;
  accent-color: #4d8b1d;
}

.asmt-actions {
  margin-top: 28px;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  flex-wrap: wrap;
}

app-asmt-footer {
  display: block;
  margin-top: auto;
}

.asmt-footer {
  background: #fff;
  border-top: 1px solid #e7eaec;
}
.asmt-footer__inner {
  max-width: 860px;
  margin: 0 auto;
  padding: 20px 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}
@media (max-width: 560px) {
  .asmt-footer__inner {
    flex-direction: column;
    gap: 6px;
    padding: 18px 20px;
    text-align: center;
  }
}
.asmt-footer__copy {
  margin: 0;
  font-size: 13px;
  color: #8a8d91;
}
.asmt-footer__copy a {
  color: #676a6c;
  text-decoration: none;
}
.asmt-footer__copy a:hover {
  color: #6d6e71;
  text-decoration: underline;
}
.asmt-footer__version {
  font-size: 11.5px;
  font-weight: 700;
  letter-spacing: 0.05em;
  color: #b6b9bc;
}

.asmt-lhero {
  display: flex;
  align-items: center;
  gap: 48px;
  padding-bottom: 12px;
}
@media (max-width: 800px) {
  .asmt-lhero {
    flex-direction: column;
    align-items: stretch;
    gap: 26px;
  }
}

.asmt-lhero__main {
  flex: 1 1 auto;
  min-width: 0;
}

.asmt-lhero__eyebrow {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 18px;
}

.asmt-lhero__dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: rgb(105, 190, 40);
  flex-shrink: 0;
}

.asmt-lhero__title {
  font-size: 46px;
  margin-bottom: 20px;
}
@media (max-width: 900px) {
  .asmt-lhero__title {
    font-size: 40px;
  }
}
@media (max-width: 640px) {
  .asmt-lhero__title {
    font-size: 34px;
  }
}

.asmt-lhero__greet {
  display: block;
}

.asmt-lhero__stmt {
  display: block;
  text-wrap: balance;
}

.asmt-lhero__lede {
  margin-bottom: 0;
  max-width: 46ch;
}

.asmt-lhero__aside {
  flex-shrink: 0;
  width: 300px;
}
@media (max-width: 800px) {
  .asmt-lhero__aside {
    width: 100%;
  }
}

.asmt-welcard {
  background: #fff;
  border: 1px solid #e7eaec;
  border-radius: 16px;
  box-shadow: 0 1px 2px rgba(51, 51, 51, 0.04), 0 16px 34px -22px rgba(51, 51, 51, 0.22);
  padding: 22px 22px 20px;
  border-top: 3px solid rgb(0, 173, 208);
}

.asmt-welcard__invite {
  display: flex;
  align-items: flex-start;
  gap: 13px;
  padding-bottom: 18px;
  margin-bottom: 16px;
  border-bottom: 1px solid #e7eaec;
}

.asmt-welcard__icon {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  border-radius: 10px;
  background: rgba(0, 173, 208, 0.12);
  color: #007a93;
  font-size: 15px;
}

.asmt-welcard__text {
  display: flex;
  flex-direction: column;
  min-width: 0;
  line-height: 1.35;
}

.asmt-welcard__label {
  font-size: 12.5px;
  font-weight: 600;
  line-height: 1.4;
  color: #00697e;
  margin-bottom: 4px;
}

.asmt-welcard__name {
  font-size: 16px;
  font-weight: 700;
  color: #6d6e71;
}

.asmt-welcard__facts {
  list-style: none;
  margin: 0;
  padding: 0;
}
.asmt-welcard__facts li {
  display: flex;
  align-items: center;
  gap: 11px;
  font-size: 13.5px;
  color: #676a6c;
  padding: 5px 0;
}
.asmt-welcard__facts li .fa {
  width: 16px;
  text-align: center;
  color: #569c21;
  font-size: 14px;
  flex-shrink: 0;
}

.asmt-lcard {
  padding: 0;
  overflow: hidden;
}
@media (max-width: 640px) {
  .asmt-lcard {
    padding: 0;
  }
}

.asmt-fsec {
  padding: 32px 40px;
}
.asmt-fsec:not(.asmt-fsec--last) {
  border-bottom: 1px solid #e7eaec;
}
@media (max-width: 640px) {
  .asmt-fsec {
    padding: 24px 20px;
  }
}

.asmt-fsec__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  margin-bottom: 20px;
}

.asmt-fsec__heading {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}

.asmt-fsec__step {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: rgba(0, 173, 208, 0.12);
  color: #00586a;
  font-size: 13px;
  font-weight: 700;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
}

.asmt-fsec__title {
  font-family: "Museo-700", "Open Sans", "Helvetica Neue", Arial, sans-serif;
  font-weight: 400;
  color: #6d6e71;
  font-size: 21px;
  letter-spacing: -0.01em;
  line-height: 1.15;
  margin: 0;
}
@media (max-width: 640px) {
  .asmt-fsec__title {
    font-size: 18px;
  }
}

.asmt-fsec__req {
  flex-shrink: 0;
  font-size: 12px;
  font-weight: 600;
  color: #8a8d91;
  white-space: nowrap;
}

.asmt-fsec__badge {
  flex-shrink: 0;
  font-size: 10.5px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #6d6e71;
  background: #f1f1f2;
  border-radius: 999px;
  padding: 4px 11px;
}

.asmt-fsec__desc {
  font-size: 14.5px;
  line-height: 1.62;
  color: #676a6c;
  margin: -6px 0 22px;
}

.asmt-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px 20px;
}
@media (max-width: 560px) {
  .asmt-grid {
    grid-template-columns: 1fr;
    gap: 18px;
  }
}
.asmt-grid .asmt-field--full {
  grid-column: 1/-1;
}
.asmt-grid .asmt-field {
  margin-bottom: 0;
}

.asmt-grid--single {
  grid-template-columns: 1fr;
  max-width: 460px;
}

.asmt-field label {
  margin-bottom: 8px;
}

.asmt-consent {
  display: flex;
  gap: 12px;
  align-items: flex-start;
  margin-top: 22px;
  padding: 16px 18px;
  font-size: 13.5px;
  line-height: 1.6;
  color: #676a6c;
  background: #f1f1f2;
  border: 1px solid #e7eaec;
  border-radius: 12px;
  cursor: pointer;
  transition: border-color 0.15s ease, background-color 0.15s ease;
}
.asmt-consent input {
  margin-top: 2px;
  flex-shrink: 0;
  width: 18px;
  height: 18px;
  accent-color: #4d8b1d;
  cursor: pointer;
}
.asmt-consent:hover {
  border-color: #d6dbde;
}

.asmt-grid .asmt-consent--field {
  margin-top: 0;
  padding: 2px 0;
  gap: 10px;
  align-items: center;
  background: none;
  border: 0;
  border-radius: 0;
  font-size: 14px;
  font-weight: 600;
  color: #6d6e71;
}
.asmt-grid .asmt-consent--field:hover {
  border-color: transparent;
}
.asmt-grid .asmt-consent--field input {
  margin-top: 0;
}

.asmt-error--consent {
  margin-top: 8px;
}

.asmt-practice {
  margin-top: 6px;
  padding: 22px 24px;
  border-radius: 14px;
  background: #f7f8f6;
  border: 1px solid #e7eaec;
}
@media (max-width: 640px) {
  .asmt-practice {
    padding: 18px 16px;
  }
}

.asmt-practice__tag {
  display: inline-block;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: #006174;
  margin-bottom: 10px;
}

.asmt-practice-text {
  font-size: 18px;
  font-weight: 700;
  color: #6d6e71;
  margin: 0 0 16px;
}

.asmt-lcard__foot {
  display: flex;
  justify-content: flex-end;
  padding: 22px 40px;
  background: #f1f1f2;
  border-top: 1px solid #e7eaec;
}
@media (max-width: 640px) {
  .asmt-lcard__foot {
    padding: 20px;
  }
  .asmt-lcard__foot .asmt-btn {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/_variables.scss","webpack://./src/app/components/assessment/landing/assessment-landing.component.scss","webpack://./src/app/components/assessment/_assessment-shell.scss"],"names":[],"mappings":"AAgIA;EACE,eAAA;AC/HF;;ADkIA;EACE,aAAA;EACA,eAAA;AC/HF;;ADkIA;EACE,sBAAA;AC/HF;;ADkIA;EACE,8BAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;ADkIA;EACE,aAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;AD6IE;;;;;;EAME,YAAA;EACA,wBA7KO;EA8KP,cA3IiB;EA4IjB,0BAAA;EACA,aAAA;AC1IJ;AD4II;;;;;;EACE,gBAAA;ACrIN;ADyIE;;EAEE,eA5GO;EA6GP,gBA3GO;AC5BX;ADyII;EALF;;IAMI,eA/GY;ECtBhB;AACF;ADwIE;;EAEE,eAlHO;EAmHP,gBAjHO;ACrBX;ADwII;EALF;;IAMI,eArHY;ECfhB;AACF;ADuIE;;EAEE,eAxHO;EAyHP,gBAvHO;ACdX;ADuII;EALF;;IAMI,eA3HY;ECRhB;AACF;ADsIE;;EAEE,eA9HO;EA+HP,gBA7HO;ACPX;ADuIE;;EAEE,eAhIO;EAiIP,gBAhIO;ACLX;ADwIE;;EAEE,eAnIO;EAoIP,gBAnIO;ACHX;AD4IE;EACE,eAAA;EACA,gBAAA;EACA,cAzMqB;EA0MrB,aAAA;EACA,mBAAA;AC1IJ;AD4II;EACE,gBAAA;AC1IN;AD6II;EAXF;IAYI,eAAA;EC1IJ;AACF;AD6IE;;EAEE,UAAA;EACA,SAAA;AC3IJ;AD8IE;EACE,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,qBAAA;EACA,mBAAA;AC5IJ;;ADgJA;EACE,sBAxNQ;AC2EV;;ADgJA;EACE,iBAlKU;EAmKV,wBAAA;EACA,mBAAA;AC7IF;AD+IE;EALF;IAMI,cAAA;EC5IF;AACF;AD8IE;EACE,iBA1Ka;AC8BjB;AD+IE;EACE,gBApLa;EAqLb,WAAA;AC7IJ;;ADkJE;EACE,kBAAA;AC/IJ;ADkJE;EACE,iBAAA;AChJJ;;ADqJE;EACE,aAAA;AClJJ;;ADsJA;EACE,kBAAA;ACnJF;ADqJE;EACE,mBAAA;ACnJJ;ADuJI;EACE,sBAAA;ACrJN;ADyJE;EACE,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,eA9Ne;ACuEnB;ADyJI;EACE,sBAAA;ACvJN;AD0JI;EAVF;IAWI,eApOoB;EC6ExB;AACF;AD0JE;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;ACxJJ;AD0JI;EACE,sBAAA;ACxJN;AD2JI;EACE,WAAA;ACzJN;AD4JI;EACE,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,4BA5VM;ACkMZ;;AD+JA;EACE,mBA1PO;AC8FT;AD8JE;EAHF;IAII,mBAAA;EC3JF;AACF;AD6JE;EACE,mBAAA;AC3JJ;AD8JE;EACE,aArQK;ACyGT;AD8JI;EAHF;IAII,aAAA;EC3JJ;AACF;AD6JI;EACE,aAAA;AC3JN;;ADgKA;EACE,gBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,+CAAA;EACA,mBAAA;EACA,kBAAA;AC7JF;AD+JE;EACE,eAAA;AC7JJ;ADgKE;EACE,sCAAA;AC9JJ;ADiKE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,uBAAA;EACA,oNAAA;AC/JJ;;AD8KE;EACE,eAAA;EACA,gBAAA;EACA,cA/XqB;EAgYrB,gBAAA;EACA,kBAAA;EACA,kBAAA;AC3KJ;AD6KI;EACE,kBAAA;AC3KN;AD8KI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,mCAAA;AC5KN;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,+BAAA;AC9KF;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,mBAAA;EACA,oBAAA;EACA,mCAzbc;EA0bd,WAzZS;EA0ZT,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,wBAhdS;EAidT,qBAAA;EACA,qBAAA;EACA,kBAAA;EACA,iCAAA;AC9KF;ADgLE;EACE,2BAAA;EACA,mBAAA;AC9KJ;ADiLE;EACE,yBAzbiB;EA0bjB,WA1aO;AC2PX;ADkLE;EACE,eAAA;EACA,mBAAA;EACA,oBAAA;AChLJ;ADmLE;EACE,yBAjckB;EAkclB,cArciB;ACoRrB;ADoLE;EACE,yBAvbS;EAwbT,WA1bO;ACwQX;ADoLI;EACE,6BAAA;AClLN;;ADuLA;EACE;IACE,uBAAA;ECpLF;EDuLA;IACE,yBAAA;ECrLF;AACF;ADwLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,+BAAA;ACtLF;;ADyLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,qBAAA;ACtLF;;ADyLA;EACE,UAAA;ACtLF;ADwLE;EACE,qBAAA;ACtLJ;;AD0LA;EACE,UAAA;ACvLF;;AD2LE;EACE,YAAA;EACA,oCAAA;EAEA,aAAA;EACA,eAAA;EACA,gCAAA;ACzLJ;AD4LM;EACE,mBAAA;AC1LR;AD+LE;EACE,2BAAA;AC7LJ;ADgME;EACE,uBAAA;AC9LJ;ADiME;EACE,mBAAA;AC/LJ;;ADoME;EACE,mBAAA;ACjMJ;ADoME;EACE,yBAAA;AClMJ;ADqME;EACE,sBAAA;ACnMJ;ADsME;EACE,uBAAA;ACpMJ;ADuME;EACE,oBAAA;ACrMJ;;AC/XA;EACE,iBAAA;EACA,mBF0BoB;EEzBpB,aAAA;EACA,sBAAA;EACA,wEFpBW;EEqBX,cFcmB;EEbnB,mCAAA;ADkYF;;AC5XA;EACE,mBF+Cc;EE9Cd,0CAAA;AD+XF;AC9XE;EACE,gBA1Bc;EA0BY,cAAA;EAAgB,kBAAA;EAC1C,aAAA;EAAe,mBAAA;EAAqB,8BAAA;EAAgC,SAAA;ADqYxE;ACpYI;EAHF;IAG8B,kBAAA;EDwY9B;AACF;ACvYE;EAAU,YAAA;EAAc,WAAA;EAAa,cAAA;AD4YvC;AC3YE;EACE,oBAAA;EAAsB,mBAAA;EAAqB,QAAA;EAC3C,iBAAA;EAAmB,gBAAA;EAAkB,sBAAA;EAAwB,yBAAA;EAC7D,gCAAA;ADkZJ;ACjZI;EACE,WAAA;EAAa,UAAA;EAAY,WAAA;EAAa,kBAAA;EACtC,6BFpBU;EEoBkB,cAAA;ADuZlC;ACrZI;EARF;IAQ8B,aAAA;EDyZ9B;AACF;;AChZA;EAAc,WAAA;EAAa,gBAjDT;EAiDmC,cAAA;EAAgB,eAAA;ADuZrE;;ACtZA;EAAsB,gBAAA;AD0ZtB;;ACtZA;EACE,WAAA;EAAa,gBAvDG;EAuDuB,cAAA;EAAgB,uBAAA;AD4ZzD;AC3ZE;EAFF;IAE8B,sBAAA;ED+Z5B;AACF;;AC9ZA;EACE,qBAAA;EAAuB,eAAA;EAAiB,gBAAA;EAAkB,sBAAA;EAC1D,yBAAA;EAA2B,cAAA;EAAoC,gBAAA;ADsajE;;ACpaA;EACE,0EA1DgB;EA0DY,gBAAA;EAAkB,cF7B3B;EE8BnB,eAAA;EAAiB,iBAAA;EAAmB,uBAAA;EAAyB,gBAAA;AD4a/D;AC3aE;EAHF;IAG8B,eAAA;ED+a5B;AACF;;AC9aA;EAAmB,eAAA;EAAiB,gBAAA;EAAkB,cFtCjC;EEsCoD,eAAA;EAAiB,SAAA;ADsb1F;;ACrbA;EACE,eAAA;EAAiB,gBAAA;EAAkB,cAlEnB;EAkEuC,mBAAA;AD2bzD;AC1bE;EAAS,cFpCU;EEoCY,gBAAA;AD8bjC;;AC1bA;EACE,0EAtEgB;EAsEY,gBAAA;EAAkB,cFzC3B;EE0CnB,eAAA;EAAiB,iBAAA;EAAmB,wBAAA;EAA0B,gBAAA;ADkchE;ACjcE;EAHF;IAG8B,eAAA;EDqc5B;AACF;;ACpcA;EAAa,eAAA;EAAiB,iBAAA;EAAmB,eAAA;EAAiB,cFlD7C;AC6frB;;AC1cA;EAAoB,cA7EF;EA6EsB,iBAAA;AD+cxC;;AC9cA;EACE,0EA7EgB;EA6EY,gBAAA;EAAkB,cFhD3B;EEiDnB,eAAA;EAAiB,uBAAA;EAAyB,mBAAA;ADqd5C;ACpdE;EAHF;IAG8B,eAAA;EDwd5B;AACF;;ACrdA;EACE,gBAAA;EAAkB,yBAAA;EAAkC,mBAAA;EACpD,kBAAA;EAAoB,mBAAA;EAAqB,sFApFxB;ADgjBnB;AC3dE;EAHF;IAG8B,kBAAA;IAAoB,mBAAA;EDgehD;AACF;;AC7dA;EACE,mBAAA;ADgeF;AC/dE;EACE,cAAA;EAAgB,iBAAA;EAAmB,gBAAA;EAAkB,yBAAA;EACrD,sBAAA;EAAwB,cFjEP;EEiE6B,kBAAA;ADselD;ACpeE;EACE,WAAA;EAAa,kBAAA;EAAoB,eAAA;EAAiB,wEF5GzC;EE6GT,cFrEiB;EEqEK,2BAAA;EAAoC,mBAAA;EAAqB,gBAAA;EAC/E,0DAAA;AD4eJ;AC3eI;EAAU,8BF1FE;EE0F4B,6CAAA;EAAkD,aAAA;ADgf9F;AC/eI;EAA0B,8BFxFZ;AC0kBlB;AChfE;EAAsB,gBAAA;EACpB,wLAAA;EACA,4BAAA;EAA8B,sCAAA;EAAwC,mBAAA;ADqf1E;;ACnfA;EAAc,eAAA;EAAiB,iBAAA;EAAmB,gBAAA;EAAkB,cAAA;AD0fpE;;ACzfA;EAAY,uBF/FM;AC4lBlB;;AC1fA;EACE,oBAAA;EAAsB,mBAAA;EAAqB,uBAAA;EAAyB,QAAA;EACpE,kBAAA;EAAoB,eAAA;EAAiB,gBAAA;EAAkB,wEF5H5C;EE6HX,2BAAA;EAA6B,kBAAA;EAAoB,eAAA;EAAiB,sBAAA;EAClE,gBAAA;EAAkB,cF3FC;EE4FnB,kFAAA;ADugBF;ACtgBE;EAAU,qBFxFS;EEwFoB,cFxFpB;ACkmBrB;ACzgBE;EAAc,aAAA;EAAe,mBAAA;AD6gB/B;AC3gBE;EACE,mBAvHc;EAuHa,WAAA;EAAa,qBAvH1B;ADsoBlB;AC9gBI;EAAU,mBAAA;EAAyC,qBAAA;EAA2C,WAAA;ADmhBlG;AClhBI;EAAoB,mBAzHN;EAyHiC,qBAzHjC;AD+oBlB;AClhBE;EAAW,WAAA;ADqhBb;ACphBE;EAAQ,kBAAA;EAAoB,eAAA;ADwhB9B;;ACphBA;EACE,aAAA;EAAe,SAAA;EAAW,uBAAA;EAAyB,kBAAA;EAAoB,mBAAA;EACvE,eAAA;EAAiB,iBAAA;EAAmB,cF9GjB;EE+GnB,mCAAA;EAAwC,yCAAA;AD8hB1C;AC7hBE;EAAM,cAAA;EAAoC,eAAA;EAAiB,eAAA;ADkiB7D;;AC9hBA;EACE,kBAAA;EAAoB,kBAAA;ADkiBtB;ACjiBE;EAAM,eAAA;EAAiB,cAhJP;EAgJ2B,mBAAA;ADsiB7C;ACriBE;EAAK,0EA/IW;EA+IiB,gBAAA;EAAkB,eAAA;EAAiB,cFlHjD;EEkHuE,gBAAA;AD4iB5F;AC3iBE;EAAI,cAlJY;EAkJQ,SAAA;EAAW,eAAA;ADgjBrC;;AC5iBA;EACE,aAAA;EAAe,SAAA;EAAW,uBAAA;EAAyB,iBAAA;EAAmB,iBAAA;EACtE,cF9HmB;EE8HA,eAAA;ADojBrB;ACnjBE;EAAQ,eAAA;EAAiB,cAAA;EAAgB,WAAA;EAAa,YAAA;EAAc,qBArJpD;AD+sBlB;;ACxjBA;EAAgB,gBAAA;EAAkB,aAAA;EAAe,yBAAA;EAA2B,SAAA;EAAW,eAAA;ADgkBvF;;AC3jBA;EAAkB,cAAA;EAAgB,gBAAA;ADgkBlC;;AC/jBA;EACE,gBAAA;EAAkB,6BAAA;ADmkBpB;AClkBE;EACE,gBAvKc;EAuKY,cAAA;EAAgB,kBAAA;EAC1C,aAAA;EAAe,mBAAA;EAAqB,8BAAA;EAAgC,SAAA;ADykBxE;ACxkBI;EAHF;IAG8B,sBAAA;IAAwB,QAAA;IAAU,kBAAA;IAAoB,kBAAA;ED+kBpF;AACF;AC9kBE;EACE,SAAA;EAAW,eAAA;EAAiB,cAzKd;AD2vBlB;ACjlBI;EAAI,cFhJa;EEgJM,qBAAA;ADqlB3B;ACrlBkD;EAAU,cF3IvC;EE2I6D,0BAAA;ADylBlF;ACvlBE;EACE,iBAAA;EAAmB,gBAAA;EAAkB,sBAAA;EAAwB,cAAA;AD4lBjE;;AA3wBA;EACE,aAAA;EAAe,mBAAA;EAAqB,SAAA;EACpC,oBAAA;AAgxBF;AA/wBE;EAHF;IAG8B,sBAAA;IAAwB,oBAAA;IAAsB,SAAA;EAqxB1E;AACF;;AApxBA;EAAoB,cAAA;EAAgB,YAAA;AAyxBpC;;AAxxBA;EACE,oBAAA;EAAsB,mBAAA;EAAqB,QAAA;EAAU,mBAAA;AA8xBvD;;AA5xBA;EACE,UAAA;EAAY,WAAA;EAAa,kBAAA;EAAoB,6BDM/B;ECN2D,cAAA;AAmyB3E;;AAjyBA;EACE,eAAA;EAAiB,mBAAA;AAqyBnB;AApyBE;EAFF;IAE8B,eAAA;EAwyB5B;AACF;AAxyBE;EAHF;IAG8B,eAAA;EA4yB5B;AACF;;AA3yBA;EAAqB,cAAA;AA+yBrB;;AA7yBA;EAAoB,cAAA;EAAgB,kBAAA;AAkzBpC;;AAjzBA;EAAoB,gBAAA;EAAkB,eAAA;AAszBtC;;AAnzBA;EACE,cAAA;EAAgB,YAAA;AAuzBlB;AAtzBE;EAFF;IAE8B,WAAA;EA0zB5B;AACF;;AAzzBA;EACE,gBAAA;EAAkB,yBAAA;EAAkC,mBAAA;EACpD,sFAAA;EACA,uBAAA;EACA,sCAAA;AA8zBF;;AA5zBA;EACE,aAAA;EAAe,uBAAA;EAAyB,SAAA;EACxC,oBAAA;EAAsB,mBAAA;EAAqB,gCAAA;AAm0B7C;;AAj0BA;EACE,cAAA;EACA,oBAAA;EAAsB,mBAAA;EAAqB,uBAAA;EAC3C,WAAA;EAAa,YAAA;EAAc,mBAAA;EAC3B,mCAAA;EAAwC,cAAA;EAAoC,eAAA;AA00B9E;;AAx0BA;EAAsB,aAAA;EAAe,sBAAA;EAAwB,YAAA;EAAc,iBAAA;AA+0B3E;;AA30BA;EACE,iBAAA;EAAmB,gBAAA;EAAkB,gBAAA;EACrC,cAAA;EAAoC,kBAAA;AAi1BtC;;AA/0BA;EAAsB,eAAA;EAAiB,gBAAA;EAAkB,cDlBpC;ACu2BrB;;AAp1BA;EACE,gBAAA;EAAkB,SAAA;EAAW,UAAA;AAy1B/B;AAx1BE;EACE,aAAA;EAAe,mBAAA;EAAqB,SAAA;EACpC,iBAAA;EAAmB,cD5BF;EC4BqB,cAAA;AA81B1C;AA71BI;EAAM,WAAA;EAAa,kBAAA;EAAoB,cAAA;EAAmC,eAAA;EAAiB,cAAA;AAo2B/F;;AA91BA;EACE,UAAA;EACA,gBAAA;AAi2BF;AAh2BE;EAHF;IAG8B,UAAA;EAo2B5B;AACF;;AAj2BA;EACE,kBAAA;AAo2BF;AAn2BE;EAA0B,gCAAA;AAs2B5B;AAr2BE;EAHF;IAG8B,kBAAA;EAy2B5B;AACF;;AAv2BA;EACE,aAAA;EAAe,mBAAA;EAAqB,8BAAA;EAAgC,SAAA;EACpE,mBAAA;AA62BF;;AA32BA;EAAsB,aAAA;EAAe,mBAAA;EAAqB,SAAA;EAAW,YAAA;AAk3BrE;;AAj3BA;EACE,cAAA;EACA,oBAAA;EAAsB,mBAAA;EAAqB,uBAAA;EAC3C,WAAA;EAAa,YAAA;EAAc,kBAAA;EAC3B,mCAAA;EAAwC,cAAA;EACxC,eAAA;EAAiB,gBAAA;EAAkB,wED7FxB;ACw9Bb;;AAz3BA;EACE,0ECrFgB;EDqFY,gBAAA;EAAkB,cDxD3B;ECyDnB,eAAA;EAAiB,uBAAA;EAAyB,iBAAA;EAAmB,SAAA;AAi4B/D;AAh4BE;EAHF;IAG8B,eAAA;EAo4B5B;AACF;;AAl4BA;EACE,cAAA;EAAgB,eAAA;EAAiB,gBAAA;EAAkB,cC7FnC;ED6FuD,mBAAA;AAy4BzE;;AAv4BA;EACE,cAAA;EACA,iBAAA;EAAmB,gBAAA;EAAkB,sBAAA;EAAwB,yBAAA;EAC7D,cDnEmB;ECmES,mBDhER;ECiEpB,oBAAA;EAAsB,iBAAA;AA+4BxB;;AA74BA;EACE,iBAAA;EAAmB,iBAAA;EAAmB,cD5EnB;EC6EnB,mBAAA;AAk5BF;;AA94BA;EACE,aAAA;EAAe,8BAAA;EAAgC,cAAA;AAm5BjD;AAl5BE;EAFF;IAE8B,0BAAA;IAA4B,SAAA;EAu5BxD;AACF;AAv5BE;EAAoB,iBAAA;AA05BtB;AAx5BE;EAAc,gBAAA;AA25BhB;;AAv5BA;EACE,0BAAA;EACA,gBAAA;AA05BF;;AAv5BA;EAAoB,kBAAA;AA25BpB;;AAx5BA;EACE,aAAA;EAAe,SAAA;EAAW,uBAAA;EAC1B,gBAAA;EAAkB,kBAAA;EAClB,iBAAA;EAAmB,gBAAA;EAAkB,cDrGlB;ECsGnB,mBD9FoB;EC8FM,yBAAA;EAAkC,mBAAA;EAC5D,eAAA;EACA,gEAAA;AAk6BF;AAj6BE;EACE,eAAA;EAAiB,cAAA;EAAgB,WAAA;EAAa,YAAA;EAAc,qBChI9C;EDgI2E,eAAA;AAw6B7F;AAt6BE;EAAU,qBAAA;AAy6BZ;;AAp6BA;EACE,aAAA;EACA,cAAA;EACA,SAAA;EACA,mBAAA;EACA,gBAAA;EACA,SAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,cDtHmB;AC6hCrB;AAt6BE;EAAU,yBAAA;AAy6BZ;AAx6BE;EAAQ,aAAA;AA26BV;;AAv6BA;EAAuB,eAAA;AA26BvB;;AAx6BA;EACE,eAAA;EAAiB,kBAAA;EAAoB,mBAAA;EACrC,mBAAA;EAAqB,yBAAA;AA86BvB;AA76BE;EAHF;IAG8B,kBAAA;EAi7B5B;AACF;;AAh7BA;EACE,qBAAA;EAAuB,eAAA;EAAiB,gBAAA;EAAkB,qBAAA;EAAuB,yBAAA;EACjF,cAAA;EAAoC,mBAAA;AAw7BtC;;AAt7BA;EAAsB,eAAA;EAAiB,gBAAA;EAAkB,cDxIpC;ECwI0D,gBAAA;AA67B/E;;AA17BA;EACE,aAAA;EAAe,yBAAA;EACf,kBAAA;EAAoB,mBD1IA;EC0I0B,6BAAA;AAg8BhD;AA/7BE;EAHF;IAII,aAAA;EAk8BF;EAj8BE;IAAY,WAAA;EAo8Bd;AACF","sourcesContent":["// Font\n$font-stack: \"open sans\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n$muso-100: \"Museo-100\";\n$muso-300: \"Museo-300\";\n$muso-300-i: \"Museo-300Italic\";\n$muso-500: \"Museo-regular\";\n$muso-700: \"Museo-700\";\n$muso-700-i: \"Museo-700Italic\";\n$muso-sans: \"MuseoSans-300\";\n$car-font: \"Marydale\";\n$car-big-font: \"Bangers\", cursive;\n$font-museo: \"Conv_museo-500-webfont\";\n$font-helvetica: \"Helvetica\", \"open sans\";\n$MuseoSansCondensed-300: \"MuseoSansCondensed-300\";\n\n$fwBold: 700;\n\n//Foursight\n// $clarify-color: #06A6CE;\n// $ideate-color: #FF8300;\n// $develop-color: #7BBC43;\n// $implement-color: #FF485C;\n$clarify-color: rgba(0, 173, 208, 1);\n$ideate-color: rgba(255, 121, 0, 1);\n$develop-color: rgba(105, 190, 40, 1);\n$implement-color: rgba(245, 67, 89, 1);\n$low-clarify-color: rgba(0, 173, 208, 1);\n$low-ideate-color: rgba(255, 121, 0, 1);\n$low-develop-color: rgba(105, 190, 40, 1);\n$low-implement-color: rgba(245, 67, 89, 1);\n$profile-connector-color: #656668;\n// Profile Neutral color\n$integrator-color: #e3e3e3;\n// Team Report\n$report-integrator: #a7a7a7;\n// Body text color in reports\n$body-content-color: #676a6c;\n// Learner Map\n$gray-lm: rgba(0, 0, 0, 0.2);\n$border-color: #aaa;\n\n$color-neutral-dark: #6d6e71;\n$color-neutral-dark-500: #6a6a6a;\n$color-neutral-mid: #ccc;\n$color-neutral-light: #f1f1f2;\n$color-neutral-mid-old: #9e9e97;\n$color-dark-green: #4cae4c;\n$color-light-grey: #d9d9d9;\n$color-red: #ff485c;\n\n$color-grey-1: #e7eaec;\n\n$clrGray1: #f6f6f6;\n\n$clrDarkGray1: #ddd;\n\n$clrGrey: #eee;\n$clrWhite: #fff;\n$clrBlack: #000;\n$clrWarning: #f8ac59;\n\n$assets: \"https://assets.foursightonline.com/app\";\n$adminUpload: \"https://assets.foursightonline.com/admin-uploads/docs/\";\n\n$separator: \"\\//\";\n\n$active-class: #017ebc;\n\n// anchor Tag\n$anchor-color: #337ab7;\n\n//Sidebar\n$color-light-type: #fff;\n// submenu background\n$fs-dark-grey: #464646;\n// Hover\n$fs-active-light: #5f5f63;\n$fs-sidenav-bg: #333333;\n$fs-sidenav-hov-bg: #3e3e3f;\n$fs-green: #69be28;\n\n$clrInputAccent: #639935;\n\n$fn-fs-h1: 44px;\n$fn-fs-h1-mobile: 38px;\n$fn-lh-h1: 1.1;\n\n$fn-fs-h2: 38px;\n$fn-fs-h2-mobile: 32px;\n$fn-lh-h2: 1.2;\n\n$fn-fs-h3: 32px;\n$fn-fs-h3-mobile: 24px;\n$fn-lh-h3: 1.2;\n\n$fn-fs-h4: 24px;\n$fn-fs-h4-mobile: 20px;\n$fn-lh-h4: 1.2;\n\n$fn-fs-h5: 18px;\n$fn-lh-h5: 1.2;\n\n$fn-fs-h6: 16px;\n$fn-lh-h6: 1.3;\n\n$fn-title-subtext: 22px;\n$fn-title-subtext-mobile: 18px;\n\n$pageWidth: 1080px;\n$pageWidthSmall: 820px;\n$pageWidthFluid: 1200px;\n\n$secPad: 60px;\n\n$pageWidth: 1080px;\n$pageWidthFluid: 1200px;\n\n$desktop: \"only screen and (max-width: 1600px)\";\n$mac: \"only screen and (max-width: 1350px)\";\n$pc-up: \"only screen and (min-width: 1200px)\";\n$pc: \"only screen and (max-width: 1199px)\";\n$tablet-up: \"only screen and (min-width: 992px)\";\n$tablet: \"only screen and (max-width: 991px)\";\n$mobile-up: \"only screen and (min-width: 768px)\";\n$mobile: \"only screen and (max-width: 767px)\";\n$xl: \"only screen and (max-width: 1440px)\";\n$xl-up: \"only screen and (min-width: 1440px)\";\n\nimg {\n  max-width: 100%;\n}\n\n.flex {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.dir-col {\n  flex-direction: column;\n}\n\n.dir-col-rev {\n  flex-direction: column-reverse;\n}\n\n.mh-full {\n  min-height: 100%;\n}\n\n.mt-auto {\n  margin-top: auto;\n}\n\n.bt-0 {\n  border-top: 0;\n}\n\n.bb-0 {\n  border-bottom: 0;\n}\n\n@mixin headingfont() {\n  font-family: $muso-700 !important;\n  font-weight: normal !important;\n}\n\n@mixin contentfont() {\n  font-family: $muso-300 !important;\n  font-weight: normal !important;\n}\n\n.fn-body {\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    --hGap: 10px;\n    font-family: $muso-700;\n    color: $color-neutral-dark;\n    margin-bottom: var(--hGap);\n    margin-top: 0;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n\n  h1,\n  .h1-text {\n    font-size: $fn-fs-h1;\n    line-height: $fn-lh-h1;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h1-mobile;\n    }\n  }\n\n  h2,\n  .h2-text {\n    font-size: $fn-fs-h2;\n    line-height: $fn-lh-h2;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h2-mobile;\n    }\n  }\n\n  h3,\n  .h3-text {\n    font-size: $fn-fs-h3;\n    line-height: $fn-lh-h3;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h3-mobile;\n    }\n  }\n\n  h4,\n  .h4-text {\n    font-size: $fn-fs-h4;\n    line-height: $fn-lh-h4;\n  }\n\n  h5,\n  .h5-text {\n    font-size: $fn-fs-h5;\n    line-height: $fn-lh-h5;\n  }\n\n  h6,\n  .h6-text {\n    font-size: $fn-fs-h6;\n    line-height: $fn-lh-h6;\n  }\n\n  $fn-title-subtext: 22px;\n  $fn-title-subtext-mobile: 18px;\n\n  p {\n    font-size: 18px;\n    line-height: 1.6;\n    color: $color-neutral-dark-500;\n    margin-top: 0;\n    margin-bottom: 10px;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n\n    @media #{$mobile} {\n      font-size: 16px;\n    }\n  }\n\n  ul,\n  ol {\n    padding: 0;\n    margin: 0;\n  }\n\n  sup {\n    font-size: 0.7em;\n    position: relative;\n    top: 5px;\n    display: inline-block;\n    vertical-align: top;\n  }\n}\n\n.bg-grey {\n  background-color: $clrGrey;\n}\n\n.fn-container {\n  max-width: $pageWidth;\n  width: calc(100% - 30px);\n  margin-inline: auto;\n\n  @media #{$tablet-up} {\n    margin-left: 0;\n  }\n\n  &--fluid {\n    max-width: $pageWidthFluid;\n  }\n\n  &--small {\n    max-width: $pageWidthSmall;\n    width: 100%;\n  }\n}\n\n.text {\n  &-center {\n    text-align: center;\n  }\n\n  &-right {\n    text-align: right;\n  }\n}\n\n.d {\n  &-none {\n    display: none;\n  }\n}\n\n.section-title {\n  text-align: center;\n\n  &:not(:last-child) {\n    margin-bottom: calc($secPad - 20px);\n  }\n\n  h2 {\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n  }\n\n  p {\n    max-width: 900px;\n    width: 100%;\n    margin-inline: auto;\n    font-size: $fn-title-subtext;\n\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n\n    @media #{$mobile} {\n      font-size: $fn-title-subtext-mobile;\n    }\n  }\n\n  .section-title__linkcontainer {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: center;\n\n    &:not(:last-child) {\n      margin-block-end: 20px;\n    }\n\n    & > * {\n      margin: 5px;\n    }\n\n    .fn-btn {\n      padding-block: 6px;\n      padding-inline: 13px;\n      font-size: 12px;\n      font-family: $muso-sans;\n    }\n  }\n}\n\n.section-padding {\n  padding-block: $secPad;\n\n  @media #{$mobile} {\n    padding-block: ($secPad - 20px);\n  }\n\n  &-small {\n    padding-block: calc($secPad / 2);\n  }\n\n  &-all {\n    padding: $secPad;\n\n    @media #{$mobile} {\n      padding: calc($secPad / 2);\n    }\n\n    &-small {\n      padding: calc($secPad / 2);\n    }\n  }\n}\n\n.headline {\n  --lineSize: 10px;\n  width: fit-content;\n  padding-block-end: calc(10px + var(--lineSize));\n  margin-inline: auto;\n  position: relative;\n\n  &--small-border {\n    --lineSize: 6px;\n  }\n\n  &:not(:last-child) {\n    margin-bottom: calc(var(--hGap) * 2.5);\n  }\n\n  &::before {\n    content: \"\";\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: var(--lineSize);\n    background: linear-gradient(\n      90deg,\n      $clarify-color 0%,\n      $clarify-color 25%,\n      $ideate-color 25%,\n      $ideate-color 50%,\n      $develop-color 50%,\n      $develop-color 75%,\n      $implement-color 75%,\n      $implement-color 100%\n    );\n  }\n}\n\n.custom-list {\n  li {\n    font-size: 18px;\n    line-height: 1.4;\n    color: $color-neutral-dark-500;\n    list-style: none;\n    position: relative;\n    padding-left: 15px;\n\n    &:not(:last-child) {\n      margin-bottom: 4px;\n    }\n\n    &::before {\n      content: \"\";\n      position: absolute;\n      top: 10px;\n      left: 0;\n      width: 3px;\n      height: 3px;\n      background-color: var(--clrProfile);\n    }\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.fn-btn {\n  padding-block: 20px;\n  padding-inline: 28px;\n  background-color: $develop-color;\n  color: $clrWhite;\n  font-size: 18px;\n  line-height: 1.2;\n  display: inline-block;\n  font-family: $muso-700;\n  text-decoration: none;\n  word-break: break-all;\n  text-align: center;\n  transition: background-color 0.3s;\n\n  &:focus {\n    outline: 1px dashed $color-neutral-dark-500;\n    outline-offset: 4px;\n  }\n\n  &:hover {\n    background-color: $color-neutral-dark;\n    color: $clrWhite;\n  }\n\n  &--sm {\n    font-size: 14px;\n    padding-block: 10px;\n    padding-inline: 20px;\n  }\n\n  &--grey {\n    background-color: $color-neutral-light;\n    color: $color-neutral-dark;\n  }\n\n  &--ongoing {\n    background-color: $clrWarning;\n    color: $clrWhite;\n\n    i {\n      animation: spin 0.3s infinite;\n    }\n  }\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.w-4 {\n  width: calc(100% / 3);\n}\n\n.w-3 {\n  width: calc(100% / 4);\n\n  &--wd {\n    width: calc(100% / 3);\n  }\n}\n\n.w-6 {\n  width: calc(100% / 2);\n}\n\n.fn {\n  &-row {\n    --rGap: 15px;\n    --rGap-minus: calc(-1 * var(--rGap));\n\n    display: flex;\n    flex-wrap: wrap;\n    margin-inline: var(--rGap-minus);\n\n    &--col-gap-exist {\n      .fn-col {\n        margin-bottom: calc($secPad / 2);\n      }\n    }\n  }\n\n  &-col {\n    padding-inline: var(--rGap);\n  }\n\n  &-justify-center {\n    justify-content: center;\n  }\n\n  &-items-center {\n    align-items: center;\n  }\n}\n\n.m {\n  &x-auto {\n    margin-inline: auto;\n  }\n\n  &l-auto {\n    margin-inline-start: auto;\n  }\n\n  &l-0 {\n    margin-inline-start: 0;\n  }\n\n  &r-auto {\n    margin-inline-end: auto;\n  }\n\n  &r-0 {\n    margin-inline-end: 0;\n  }\n}\n","@import \"../../../../assets/styles/variables\";\n@import \"../assessment-shell\";\n\n// Landing overhaul — grouped, numbered sections with an even vertical rhythm.\n// Stays on the FourSight brand (Museo display, Clarify blue, Develop green,\n// neutral greys); adds clearer hierarchy + spacing than the flat card had.\n\n// --- Welcome hero: two columns — greeting on the left, invitation card on the right ---\n.asmt-lhero {\n  display: flex; align-items: center; gap: 48px;\n  padding-bottom: 12px;\n  @media (max-width: 800px) { flex-direction: column; align-items: stretch; gap: 26px; }\n}\n.asmt-lhero__main { flex: 1 1 auto; min-width: 0; }\n.asmt-lhero__eyebrow {\n  display: inline-flex; align-items: center; gap: 8px; margin-bottom: 18px;\n}\n.asmt-lhero__dot {\n  width: 7px; height: 7px; border-radius: 50%; background: $develop-color; flex-shrink: 0;\n}\n.asmt-lhero__title {\n  font-size: 46px; margin-bottom: 20px;\n  @media (max-width: 900px) { font-size: 40px; }\n  @media (max-width: 640px) { font-size: 34px; }\n}\n.asmt-lhero__greet { display: block; }\n// the statement balances across lines so no single word is orphaned\n.asmt-lhero__stmt { display: block; text-wrap: balance; }\n.asmt-lhero__lede { margin-bottom: 0; max-width: 46ch; }\n\n// invitation card (right column)\n.asmt-lhero__aside {\n  flex-shrink: 0; width: 300px;\n  @media (max-width: 800px) { width: 100%; }\n}\n.asmt-welcard {\n  background: #fff; border: 1px solid $asmt-hairline; border-radius: 16px;\n  box-shadow: 0 1px 2px rgba(#333, 0.04), 0 16px 34px -22px rgba(#333, 0.22);\n  padding: 22px 22px 20px;\n  border-top: 3px solid $clarify-color;\n}\n.asmt-welcard__invite {\n  display: flex; align-items: flex-start; gap: 13px;\n  padding-bottom: 18px; margin-bottom: 16px; border-bottom: 1px solid $asmt-hairline;\n}\n.asmt-welcard__icon {\n  flex-shrink: 0;\n  display: inline-flex; align-items: center; justify-content: center;\n  width: 38px; height: 38px; border-radius: 10px;\n  background: rgba($clarify-color, 0.12); color: darken($clarify-color, 12%); font-size: 15px;\n}\n.asmt-welcard__text { display: flex; flex-direction: column; min-width: 0; line-height: 1.35; }\n// A sentence now, not the eyebrow fragment (\"YOU'VE BEEN INVITED TO\") this used to be —\n// so it loses the uppercase and letter-spacing, which a full sentence with a full stop\n// can't carry.\n.asmt-welcard__label {\n  font-size: 12.5px; font-weight: 600; line-height: 1.4;\n  color: darken($clarify-color, 16%); margin-bottom: 4px;\n}\n.asmt-welcard__name { font-size: 16px; font-weight: 700; color: $asmt-heading; }\n.asmt-welcard__facts {\n  list-style: none; margin: 0; padding: 0;\n  li {\n    display: flex; align-items: center; gap: 11px;\n    font-size: 13.5px; color: $asmt-body; padding: 5px 0;\n    .fa { width: 16px; text-align: center; color: darken($develop-color, 8%); font-size: 14px; flex-shrink: 0; }\n  }\n}\n\n// The form card holds sections with their own padding; zero the shell card\n// padding so section dividers span edge-to-edge and rhythm is section-driven.\n.asmt-lcard {\n  padding: 0;\n  overflow: hidden;\n  @media (max-width: 640px) { padding: 0; }\n}\n\n// --- form section ---\n.asmt-fsec {\n  padding: 32px 40px;\n  &:not(.asmt-fsec--last) { border-bottom: 1px solid $asmt-hairline; }\n  @media (max-width: 640px) { padding: 24px 20px; }\n}\n\n.asmt-fsec__head {\n  display: flex; align-items: center; justify-content: space-between; gap: 14px;\n  margin-bottom: 20px;\n}\n.asmt-fsec__heading { display: flex; align-items: center; gap: 12px; min-width: 0; }\n.asmt-fsec__step {\n  flex-shrink: 0;\n  display: inline-flex; align-items: center; justify-content: center;\n  width: 28px; height: 28px; border-radius: 50%;\n  background: rgba($clarify-color, 0.12); color: darken($clarify-color, 20%);\n  font-size: 13px; font-weight: 700; font-family: $font-stack;\n}\n.asmt-fsec__title {\n  font-family: $asmt-display; font-weight: 400; color: $asmt-heading;\n  font-size: 21px; letter-spacing: -0.01em; line-height: 1.15; margin: 0;\n  @media (max-width: 640px) { font-size: 18px; }\n}\n// right-aligned hints in the section header\n.asmt-fsec__req {\n  flex-shrink: 0; font-size: 12px; font-weight: 600; color: $asmt-muted; white-space: nowrap;\n}\n.asmt-fsec__badge {\n  flex-shrink: 0;\n  font-size: 10.5px; font-weight: 700; letter-spacing: 0.08em; text-transform: uppercase;\n  color: $color-neutral-dark; background: $color-neutral-light;\n  border-radius: 999px; padding: 4px 11px;\n}\n.asmt-fsec__desc {\n  font-size: 14.5px; line-height: 1.62; color: $asmt-body;   // AA-readable, not the pale muted grey\n  margin: -6px 0 22px;   // spans the full section width, matching the fields below\n}\n\n// --- field grid: consistent row + column gaps drive the rhythm ---\n.asmt-grid {\n  display: grid; grid-template-columns: 1fr 1fr; gap: 20px 20px;\n  @media (max-width: 560px) { grid-template-columns: 1fr; gap: 18px; }\n  .asmt-field--full { grid-column: 1 / -1; }\n  // the grid owns spacing now — drop the shell field's bottom margin\n  .asmt-field { margin-bottom: 0; }\n}\n// The demographic survey reads as one ordered list of questions, so it stays single\n// column at every width. Capped so the short selects don't stretch the full card.\n.asmt-grid--single {\n  grid-template-columns: 1fr;\n  max-width: 460px;\n}\n// slightly roomier label→input gap for a calmer form\n.asmt-field label { margin-bottom: 8px; }\n\n// --- consent: a distinct inset block grouped under the identity fields ---\n.asmt-consent {\n  display: flex; gap: 12px; align-items: flex-start;\n  margin-top: 22px; padding: 16px 18px;\n  font-size: 13.5px; line-height: 1.6; color: $asmt-body;\n  background: $asmt-canvas; border: 1px solid $asmt-hairline; border-radius: 12px;\n  cursor: pointer;\n  transition: border-color 0.15s ease, background-color 0.15s ease;\n  input {\n    margin-top: 2px; flex-shrink: 0; width: 18px; height: 18px; accent-color: $asmt-primary; cursor: pointer;\n  }\n  &:hover { border-color: darken($asmt-hairline, 6%); }\n}\n// The full-time-student question reuses the consent checkbox inside the demographics grid, but as a\n// LIGHT inline field — not the bordered callout the anonymity consent uses. Otherwise a simple yes/no\n// reads as a second consent and breaks the form's rhythm.\n.asmt-grid .asmt-consent--field {\n  margin-top: 0;\n  padding: 2px 0;\n  gap: 10px;\n  align-items: center;\n  background: none;\n  border: 0;\n  border-radius: 0;\n  font-size: 14px;\n  font-weight: 600;\n  color: $asmt-heading;\n  &:hover { border-color: transparent; }\n  input { margin-top: 0; }\n}\n// The anonymity ack sits above the demographic grid (unlike the Section 1 terms consent, which ends\n// its section) — give it bottom breathing room so the first field label doesn't crowd the box.\n.asmt-error--consent { margin-top: 8px; }\n\n// --- practice example (kept, tightened rhythm) ---\n.asmt-practice {\n  margin-top: 6px; padding: 22px 24px; border-radius: 14px;\n  background: #f7f8f6; border: 1px solid $color-grey-1;\n  @media (max-width: 640px) { padding: 18px 16px; }\n}\n.asmt-practice__tag {\n  display: inline-block; font-size: 11px; font-weight: 700; letter-spacing: 0.1em; text-transform: uppercase;\n  color: darken($clarify-color, 18%); margin-bottom: 10px;\n}\n.asmt-practice-text { font-size: 18px; font-weight: 700; color: $asmt-heading; margin: 0 0 16px; }\n\n// --- action footer inside the card ---\n.asmt-lcard__foot {\n  display: flex; justify-content: flex-end;\n  padding: 22px 40px; background: $asmt-canvas; border-top: 1px solid $asmt-hairline;\n  @media (max-width: 640px) {\n    padding: 20px;\n    .asmt-btn { width: 100%; }\n  }\n}\n","// Shared shell for the public assessment flow (landing / pay / questions / thanks).\n// ViewEncapsulation.None everywhere, so every selector is namespaced `asmt-`.\n// Consumers must `@import \"…/assets/styles/variables\"` BEFORE importing this partial.\n\n// --- brand tokens (aligned to the app: light-grey headings, brand neutrals, green primary) ---\n$asmt-header-bg:  $fs-sidenav-bg;          // #333, matches the app sidebar\n$asmt-canvas:     $color-neutral-light;    // #f1f1f2, the app page background\n$asmt-content:    860px;                   // shared content column width across the flow (original assessment width)\n$asmt-heading:    $color-neutral-dark;     // #6d6e71, brand heading grey\n$asmt-body:       $body-content-color;     // #676a6c, brand body text\n$asmt-muted:      #8a8d91;                 // readable muted grey\n$asmt-hairline:   $color-grey-1;           // #e7eaec, brand hairline\n$asmt-display:    \"Museo-700\", \"Open Sans\", \"Helvetica Neue\", Arial, sans-serif;\n$asmt-card-shadow: 0 1px 2px rgba(#333, 0.05), 0 12px 30px -18px rgba(#333, 0.16);\n$asmt-primary:    darken($develop-color, 12%);   // WCAG AA green for white text\n\n.asmt-page {\n  min-height: 100vh;\n  background: $asmt-canvas;\n  display: flex;\n  flex-direction: column;\n  font-family: $font-stack;\n  color: $asmt-body;\n  -webkit-font-smoothing: antialiased;\n}\n\n// --- top bar (matches the app sidebar; white logo on dark) ---\n// Full-width bar: logo hugs the left page margin, meta the right, so the dark\n// bar reads as a balanced header instead of a narrow boxed strip.\n.asmt-topbar {\n  background: $asmt-header-bg;\n  border-bottom: 3px solid $develop-color;   // brand accent under the bar\n  &__inner {\n    max-width: $asmt-content; margin: 0 auto; padding: 18px 16px;\n    display: flex; align-items: center; justify-content: space-between; gap: 16px;\n    @media (max-width: 640px) { padding: 14px 18px; }\n  }\n  &__logo { height: 32px; width: auto; display: block; }\n  &__meta {\n    display: inline-flex; align-items: center; gap: 9px;\n    font-size: 11.5px; font-weight: 700; letter-spacing: 0.14em; text-transform: uppercase;\n    color: rgba(#fff, 0.72);\n    &::before {\n      content: \"\"; width: 7px; height: 7px; border-radius: 50%;\n      background: $develop-color; flex-shrink: 0;\n    }\n    @media (max-width: 560px) { display: none; }\n  }\n}\n// --- content shells ---\n// `width: 100%` is load-bearing. These are direct children of `.asmt-page`, which is a flex\n// column — and an auto cross-axis margin overrides `align-items: stretch`, so `margin: 0 auto`\n// alone left the box shrink-to-fit. Its width then tracked the widest content in it: the\n// question card resized per statement (49 chars → 775px, 89 chars → the 860px cap), which reads\n// as the layout twitching every time you answer. Pinning the width keeps the column fixed; the\n// auto margins still centre it.\n.asmt-shell { width: 100%; max-width: $asmt-content; margin: 0 auto; padding: 0 16px; }\n.asmt-shell--narrow { max-width: 520px; }\n\n// --- editorial hero (landing / thanks) ---\n// width: 100% for the same reason as .asmt-shell — also a direct flex child of .asmt-page.\n.asmt-hero {\n  width: 100%; max-width: $asmt-content; margin: 0 auto; padding: 48px 16px 12px;\n  @media (max-width: 640px) { padding: 36px 18px 8px; }\n}\n.asmt-eyebrow {\n  display: inline-block; font-size: 12px; font-weight: 700; letter-spacing: 0.16em;\n  text-transform: uppercase; color: darken($clarify-color, 18%); margin: 0 0 16px;\n}\n.asmt-hero__title {\n  font-family: $asmt-display; font-weight: 400; color: $asmt-heading;\n  font-size: 52px; line-height: 1.04; letter-spacing: -0.02em; margin: 0 0 18px;\n  @media (max-width: 640px) { font-size: 34px; }\n}\n.asmt-hero__lede { font-size: 18px; line-height: 1.6; color: $asmt-body; max-width: 62ch; margin: 0; }\n.asmt-hero__context {\n  font-size: 15px; line-height: 1.5; color: $asmt-muted; margin: -6px 0 18px;\n  strong { color: $asmt-heading; font-weight: 700; }\n}\n\n// --- generic type ---\n.asmt-title {\n  font-family: $asmt-display; font-weight: 400; color: $asmt-heading;\n  font-size: 32px; line-height: 1.12; letter-spacing: -0.015em; margin: 0 0 12px;\n  @media (max-width: 640px) { font-size: 26px; }\n}\n.asmt-lede { font-size: 16px; line-height: 1.62; margin: 0 0 8px; color: $asmt-body; }\n.asmt-lede--muted { color: $asmt-muted; font-size: 14.5px; }\n.asmt-section {\n  font-family: $asmt-display; font-weight: 400; color: $asmt-heading;\n  font-size: 20px; letter-spacing: -0.01em; margin: 32px 0 12px;\n  @media (max-width: 640px) { font-size: 18px; }\n}\n\n// --- card ---\n.asmt-card {\n  background: #fff; border: 1px solid $asmt-hairline; border-radius: 18px;\n  padding: 36px 40px; margin-bottom: 22px; box-shadow: $asmt-card-shadow;\n  @media (max-width: 640px) { padding: 24px 20px; border-radius: 14px; }\n}\n\n// --- fields ---\n.asmt-field {\n  margin-bottom: 18px;\n  label {\n    display: block; font-size: 11.5px; font-weight: 700; text-transform: uppercase;\n    letter-spacing: 0.06em; color: $asmt-heading; margin-bottom: 7px;\n  }\n  .form-control {\n    width: 100%; padding: 12px 14px; font-size: 15px; font-family: $font-stack;\n    color: $asmt-heading; border: 1.5px solid $asmt-hairline; border-radius: 10px; background: #fff;\n    transition: border-color 0.15s ease, box-shadow 0.15s ease;\n    &:focus { border-color: $clarify-color; box-shadow: 0 0 0 4px rgba($clarify-color, 0.14); outline: none; }\n    &.ng-invalid.ng-touched { border-color: $implement-color; }\n  }\n  select.form-control { appearance: none;\n    background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8'%3E%3Cpath fill='%23767b83' d='M6 8 0 0h12z'/%3E%3C/svg%3E\");\n    background-repeat: no-repeat; background-position: right 16px center; padding-right: 40px; }\n}\n.asmt-error { margin-top: 6px; font-size: 12.5px; font-weight: 600; color: darken($implement-color, 8%); }\n.asmt-req { color: $implement-color; }\n\n// --- buttons: one system. white/bordered default, green filled primary. ---\n.asmt-btn {\n  display: inline-flex; align-items: center; justify-content: center; gap: 9px;\n  padding: 12px 24px; font-size: 14px; font-weight: 700; font-family: $font-stack;\n  border: 1.5px solid #d3d6d8; border-radius: 8px; cursor: pointer; letter-spacing: 0.01em;\n  background: #fff; color: $asmt-body;\n  transition: background-color 0.15s ease, border-color 0.15s ease, color 0.15s ease;\n  &:hover { border-color: $asmt-heading; color: $asmt-heading; }\n  &[disabled] { opacity: 0.45; cursor: not-allowed; }\n\n  &--primary {\n    background: $asmt-primary; color: #fff; border-color: $asmt-primary;\n    &:hover { background: darken($develop-color, 18%); border-color: darken($develop-color, 18%); color: #fff; }\n    &[disabled]:hover { background: $asmt-primary; border-color: $asmt-primary; }\n  }\n  // legacy alias — secondary buttons already inherit the default bordered style\n  &--ghost { }\n  &--block { width: 100%; }\n  &--lg { padding: 14px 30px; font-size: 15px; }\n}\n\n// --- notes / callouts ---\n.asmt-note {\n  display: flex; gap: 10px; align-items: flex-start; padding: 14px 16px; border-radius: 12px;\n  font-size: 14px; line-height: 1.55; color: $asmt-body;\n  background: rgba($clarify-color, 0.07); border: 1px solid rgba($clarify-color, 0.22);\n  .fa { color: darken($clarify-color, 12%); margin-top: 2px; font-size: 15px; }\n}\n\n// --- invalid / closed empty states ---\n.asmt-state {\n  text-align: center; padding: 64px 24px;\n  .fa { font-size: 44px; color: $asmt-muted; margin-bottom: 16px; }\n  h2 { font-family: $asmt-display; font-weight: 400; font-size: 24px; color: $asmt-heading; margin: 0 0 10px; }\n  p { color: $asmt-muted; margin: 0; font-size: 15px; }\n}\n\n// --- terms checkbox row ---\n.asmt-terms {\n  display: flex; gap: 12px; align-items: flex-start; font-size: 13.5px; line-height: 1.55;\n  color: $asmt-body; cursor: pointer;\n  input { margin-top: 3px; flex-shrink: 0; width: 17px; height: 17px; accent-color: $asmt-primary; }\n}\n.asmt-actions { margin-top: 28px; display: flex; justify-content: flex-end; gap: 12px; flex-wrap: wrap; }\n\n// --- footer (light bar; copyright + app version) ---\n// The <app-asmt-footer> host is the flex child of .asmt-page, so the sticky\n// push-to-bottom margin lives on the host, not the inner bar.\napp-asmt-footer { display: block; margin-top: auto; }\n.asmt-footer {\n  background: #fff; border-top: 1px solid $asmt-hairline;\n  &__inner {\n    max-width: $asmt-content; margin: 0 auto; padding: 20px 24px;\n    display: flex; align-items: center; justify-content: space-between; gap: 12px;\n    @media (max-width: 560px) { flex-direction: column; gap: 6px; padding: 18px 20px; text-align: center; }\n  }\n  &__copy {\n    margin: 0; font-size: 13px; color: $asmt-muted;\n    a { color: $asmt-body; text-decoration: none; &:hover { color: $asmt-heading; text-decoration: underline; } }\n  }\n  &__version {\n    font-size: 11.5px; font-weight: 700; letter-spacing: 0.05em; color: #b6b9bc;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
